export const proTaxonomies = [
    'procustomer',
    'proffkunde',
    'procontent',
    'proffinnhold',
];
